var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.138,8.55 C13.607442,8.55 13.988,8.93055796 13.988,9.4 C13.988,9.83333111 13.6637376,10.1909267 13.2446222,10.2433773 L13.138,10.25 L9.4,10.25 C9.12661905,10.25 8.89982381,10.4494571 8.85719857,10.7107871 L8.85,10.8 L8.85,20.6 C8.85,20.873381 9.04945714,21.1001762 9.31078714,21.1428014 L9.4,21.15 L19.2,21.15 C19.473381,21.15 19.7001762,20.9505429 19.7428014,20.6892129 L19.75,20.6 L19.75,16.862 C19.75,16.392558 20.130558,16.012 20.6,16.012 C21.0333311,16.012 21.3909267,16.3362624 21.4433773,16.7553778 L21.45,16.862 L21.45,20.6 C21.45,21.790864 20.5248384,22.7656449 19.3540488,22.8448092 L19.2,22.85 L9.4,22.85 C8.20913601,22.85 7.23435508,21.9248384 7.15519081,20.7540488 L7.15,20.6 L7.15,10.8 C7.15,9.60913601 8.07516159,8.63435508 9.24595119,8.55519081 L9.4,8.55 L13.138,8.55 Z M18.5989592,7.39895924 C18.9309049,7.06701359 19.4690951,7.06701359 19.8010408,7.39895924 L19.8010408,7.39895924 L22.6010408,10.1989592 C22.9329864,10.5309049 22.9329864,11.0690951 22.6010408,11.4010408 L22.6010408,11.4010408 L15.6010408,18.4010408 C15.4416348,18.5604467 15.225434,18.65 15,18.65 L15,18.65 L12.2,18.65 C11.730558,18.65 11.35,18.269442 11.35,17.8 L11.35,17.8 L11.35,15 C11.35,14.774566 11.4395533,14.5583652 11.5989592,14.3989592 L11.5989592,14.3989592 Z M19.2,9.203 L13.05,15.352 L13.05,16.95 L14.646,16.95 L20.797,10.8 L19.2,9.203 Z",
    id: "Icon",
    fill: "#365EDE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ebf27ee3.svg";
export { ForwardRef as ReactComponent };